module.exports = __webpack_public_path__ + "officialStatic/img/productB37.9e5aeee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB37.png
// module id = th6F
// module chunks = 0